module.exports = __webpack_public_path__ + "img/esteeDW2.2e6fc931.jpg";